export default __webpack_public_path__ + "static/media/company.56287eb7.jpg";